(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('ProgramaEducativo', ProgramaEducativo);

    ProgramaEducativo.$inject = ['$resource'];

    function ProgramaEducativo ($resource) {
        var resourceUrl =  'api/programa-educativos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { 
            	method: 'GET',
            	url:'api/programa-educativos-all',
            	isArray: true
           	},
            'distinct': { 
            	method: 'GET',
            	url:'api/programas-educativos-distinct',
            	isArray: true
           	},
            'allByCentroDocente': { 
            	method: 'GET',
            	url:'api/programa-educativos-all/:idCentroDocente',
            	isArray: true
           	},
            'getByCurrentUser': {
                method: 'GET',
            	url:'api/programa-educativos-by-current-user',
            	isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
